import { shape, string, number, arrayOf, oneOfType } from 'prop-types'

export const GroupPersonType = shape({
  points: number,
  groups: arrayOf(
    shape({
      groupId: oneOfType([string, number]),
      treeId: oneOfType([string, number]),
    })
  ),
  memberCisId: string,
  userProfileName: string,
  portraitUrl: string,
})

export const FamilyGroupType = shape({
  familyGroupId: oneOfType([string, number]),
  name: string,
  imageUrl: string,
  persons: arrayOf(GroupPersonType),
})
